import { FC, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useQuery } from '@apollo/client';
import { HELP_ROUTE } from 'components/help/constants';
import ELEMENT from 'common/element';
import { Permission } from 'common/graphqlTypes';
import { hasPermissionState } from 'components/account/account.state';

import Page from 'components/common/Page/Page';
import PageHeader from 'components/common/PageHeader/PageHeader';

import { SecretData } from './types';
import SecretsTable from './SecretsTable/SecretsTable';
import AddSecretDialog from './Dialogs/AddSecretDialog';
import { SECRETS_DATA } from './queries';

const SecretsPage: FC = () => {
  const { data, refetch } = useQuery<SecretData>(SECRETS_DATA);
  const hasFullAccessPermission = useRecoilValue(hasPermissionState(Permission.fullAccess));
  const [addSecretDialogIsOpen, setAddSecretDialogIsOpen] = useState(false);
  const buttons = [
    {
      name: ' Add Secret',
      onClick: (): void => {
        setAddSecretDialogIsOpen(true);
      },
      disabled: !hasFullAccessPermission,
      testId: ELEMENT.addSecretButton,
    },
  ];

  const handleChange = (): void => {
    refetch();
  };

  return (
    <Page docTitle="Secrets" testId={ELEMENT.secretsPage}>
      <PageHeader title="Secrets" helpLink={HELP_ROUTE.HELP_SECRETS} additionalRightButtons={buttons} />
      <SecretsTable data={data} />
      <AddSecretDialog
        handleChange={handleChange}
        addSecretDialogIsOpen={addSecretDialogIsOpen}
        setAddSecretDialogIsOpen={setAddSecretDialogIsOpen}
      />
    </Page>
  );
};

export default SecretsPage;
